import { NAV_ITEMS } from '@shared/constants/navigation';

import { APP_TEXT } from '../constants';

/** Stand-in for a screen that a later roadmap phase delivers. */
export function PlaceholderPage({ path }: { path: string }) {
  const item = NAV_ITEMS.find((n) => n.path === path);
  return (
    <section className="flex flex-col gap-2">
      <h1 className="text-[23px] font-bold">{item?.label ?? APP_TEXT.placeholder.comingSoon}</h1>
      <p className="text-[13px] text-text-2">
        {item ? APP_TEXT.placeholder.phase(item.phase) : APP_TEXT.placeholder.notBuilt}
      </p>
    </section>
  );
}
